document.addEventListener( 'DOMContentLoaded', () => {
	/**
	 * Toggle the Checkbox state for the Composite Product Page on the Bundled products.
	 */
	const form = document.querySelector( '.composite_form.progressive' );

	if ( ! form ) {
		return;
	}

	form.addEventListener( 'click', event => {
		// Get clicked element
		const clickedElement = event.target.closest( '.bundled_product .item_title' );
		if ( ! clickedElement ) {
			return;
		}

		// Get it's parent element
		const parent = clickedElement.closest( '.details' );
		if ( ! parent ) {
			return;
		}

		// Get the checkbox inside
		const checkbox = parent.querySelector( '.bundled_product_checkbox' );
		if ( ! checkbox ) {
			return;
		}

		// Create a click event (to run the JS code related to the checkbox)
		const clickEvent = new MouseEvent( 'click', { //eslint-disable-line no-undef
			view: window,
			bubbles: true,
			cancelable: true,
		} );

		// Apply click event on the checkbox.
		checkbox.dispatchEvent( clickEvent );
	} );
} );
